// Charts list actions.
export const REQUEST_CHARTS = 'REQUEST_CHARTS';
export const RECEIVE_CHARTS = 'RECEIVE_CHARTS';
export const SORT_CHARTS = 'SORT_CHARTS';
export const SET_INITIAL_CHARTS_FILTER = 'SET_INITIAL_CHARTS_FILTER';
export const UPDATE_CHARTS_FILTER = 'UPDATE_CHARTS_FILTER';
export const RESET_CHARTS_FILTER = 'RESET_CHARTS_FILTER';
export const TOGGLE_CHARTS_FILTER = 'TOGGLE_CHARTS_FILTER';

// Publishing.
export const EXPORT_IMAGE = 'EXPORT_IMAGE';
export const APPROVE_CHART = 'APPROVE_CHART';
export const PUBLISH_START = 'PUBLISH_START';
export const PUBLISH_STEP = 'PUBLISH_STEP';
export const PUBLISH_COMPLETE = 'PUBLISH_COMPLETE';
export const PRINT_INFO = 'PRINT_INFO';

// Documents management.
export const CREATE_CHART = 'CREATE_CHART';
export const CREATE_CHART_COMPLETE = 'CREATE_CHART_COMPLETE';
export const IMPORT_CHART = 'IMPORT_CHART';
export const CREATE_CHART_COMPLETE_DUPLICATE = 'CREATE_CHART_COMPLETE_DUPLICATE';

export const DESTROY_CHART = 'DESTROY_CHART';
export const REQUEST_CHART = 'REQUEST_CHART';
export const RECEIVE_CHART = 'RECEIVE_CHART';
export const DELETE_CHART = 'DELETE_CHART';

// Chart data, exporting, publishing management.
export const UPDATE_CHART_COMPLETE = 'UPDATE_CHART_COMPLETE';
export const PUBLISH_CHART = 'PUBLISH_CHART';

// Data import and parsing.
export const UPDATE_INPUT_DATA = 'UPDATE_INPUT_DATA';
export const RECEIVE_INPUT_DATA = 'RECEIVE_INPUT_DATA';
export const UPDATE_PARSED_DATA = 'UPDATE_PARSED_DATA';
export const UPDATE_MARKETDATA = 'UPDATE_MARKETDATA';
export const LIST_COMPANIES = 'LIST_COMPANIES';
export const UPDATE_DATA_FIELD = 'UPDATE_DATA_FIELD';

// Data sourcing notes
export const UPDATE_DATA_NOTES = 'UPDATE_DATA_NOTES';

// Chart options.
export const SET_CHARTS_VISIBILITY = 'SET_CHARTS_VISIBILITY';
export const SELECT_ADJUSTED_CHART_POINT = 'SELECT_ADJUSTED_CHART_POINT';
export const SELECT_CHART_POINT = 'SELECT_CHART_POINT';
export const UPDATE_SERIES_NAME = 'UPDATE_SERIES_NAME';
export const UPDATE_SERIES_ORDER = 'UPDATE_SERIES_ORDER';
export const UPDATE_SERIES_MARKDOWN = 'UPDATE_SERIES_MARKDOWN';
export const HIDE_SERIES_LEGEND = 'HIDE_SERIES_LEGEND';
export const UPDATE_CHART_TYPE = 'UPDATE_CHART_TYPE';
export const UPDATE_TARGETS = 'UPDATE_TARGETS';
export const UPDATE_GROUPS = 'UPDATE_GROUPS';
export const UPDATE_SECTIONS = 'UPDATE_SECTIONS';
export const UPDATE_DATETIME_SUPPRESSION = 'UPDATE_DATETIME_SUPPRESSION';
export const TOGGLE_ROLLING = 'TOGGLE_ROLLING';
export const SINGLE_IS_PERCENT = 'SINGLE_IS_PERCENT';
export const ENABLE_MARKDOWN = 'ENABLE_MARKDOWN';
export const UPDATE_LEGEND = 'UPDATE_LEGEND';
export const UPDATE_LEGEND_LAYOUT = 'UPDATE_LEGEND_LAYOUT';
export const UPDATE_DATA_COLOR = 'UPDATE_DATA_COLOR';
export const UPDATE_SERIES_COLOR = 'UPDATE_SERIES_COLOR';
export const UPDATE_SERIES_LINE = 'UPDATE_SERIES_LINE';
export const UPDATE_COLOR = 'UPDATE_COLOR';
export const UPDATE_ANNOTATION = 'UPDATE_ANNOTATION';
export const UPDATE_STACKING = 'UPDATE_STACKING';
export const UPDATE_WIDTH = 'UPDATE_WIDTH';
export const UPDATE_SIZE_PROP = 'UPDATE_HEIGHT';
export const SET_WIDTH_HEIGHT_MANUALLY = 'SET_WIDTH_HEIGHT_MANUALLY';
export const UPDATE_GLOBAL_HEIGHT = 'UPDATE_GLOBAL_HEIGHT';

export const UPDATE_SPECIAL_HORIZONTALBAR_XVALUE = 'UPDATE_SPECIAL_HORIZONTALBAR_XVALUE';
export const UPDATE_HORIZONTAL_BAR_LABEL = 'UPDATE_HORIZONTAL_BAR_LABEL';

export const UPDATE_SHOW_MINOR_TICKS = 'UPDATE_SHOW_MINOR_TICKS';

export const UPDATE_SHOW_TOOLTIPS = 'UPDATE_SHOW_TOOLTIPS';

export const UPDATE_CONNECT_EMPTY_DATA_POINTS = 'UPDATE_CONNECT_EMPTY_DATA_POINTS';

export const UPDATE_SHOW_MARKED_DATA_POINTS = 'UPDATE_SHOW_MARKED_DATA_POINTS';

// Axes.
export const UPDATE_NUMERIC_DATA_DISPLAY = 'UPDATE_NUMERIC_DATA_DISPLAY';
export const UPDATE_TICK_STYLE = 'UPDATE_TICK_STYLE';
export const UPDATE_AXES_VISIBILITY = 'UPDATE_AXES_VISIBILITY';
export const UPDATE_AXES_PROPERTY = 'UPDATE_AXES_PROPERTY';

export const UPDATE_HORIZONTAL_BAR_TYPE = 'UPDATE_HORIZONTAL_BAR_TYPE';
